// extracted by mini-css-extract-plugin
export var label = "_gd-2";
export var slideContainer = "_gd-0";
export var slider = "_gd-1";